import { day as DAY_COLORS_JSON } from '@eventbrite/eds-settings';
import PropTypes from 'prop-types';
// Colors
import COLORS_JSON from './color_colors.json';
import GREYS_JSON from './color_greys.json';
import REBRANDING_JSON from './color_rebranding_colors.json';

export const COLORS = [
    // Legacy color names
    ...Object.keys(COLORS_JSON),
    ...Object.keys(GREYS_JSON),
    // Theme color names
    ...Object.keys(DAY_COLORS_JSON),
    // Rebranding color names
    ...Object.keys(REBRANDING_JSON),
];

export const COLORS_PROP_TYPE = PropTypes.oneOf(COLORS);

export { COLORS_JSON, GREYS_JSON, DAY_COLORS_JSON, REBRANDING_JSON };
